/**
 * Domain-based branding.
 *
 * The Colabor8-skinned deployments show the Colabor8 logo everywhere the
 * Sidekick logo would normally appear. All other domains keep the default
 * Sidekick branding.
 */
const COLABOR8_HOSTS = ['colabor8.stellair.ai', 'webenza.stellair.ai'];

export const isColabor8 =
  typeof window !== 'undefined' &&
  COLABOR8_HOSTS.includes(window.location.hostname);

export const brandName = isColabor8 ? 'Colabor8' : 'Sidekick';

// Sidekick ships three logo variants (light-background wordmark, white
// wordmark for the dark sidebar, square icon). Colabor8 uses the Colabor8
// wordmark for the main and expanded-sidebar placements, and the compact
// "8" mark for the collapsed-sidebar square slot (where a wide wordmark
// can't fit) and the favicon.
export const brandLogos = {
  main: isColabor8 ? '/colabor8-logo.png' : '/logo.png',
  white: isColabor8 ? '/colabor8-logo.png' : '/logo-white.png',
  square: isColabor8 ? '/colabor8-mark.png' : '/logo-square.png',
};

/**
 * Swaps the favicon to the brand mark on branded domains. The favicon is
 * baked into index.html, so it has to be replaced at runtime.
 */
export function applyBranding() {
  if (!isColabor8) return;
  const link = document.querySelector("link[rel~='icon']");
  if (link) link.href = '/colabor8-mark.png';
}
